module.exports = __webpack_public_path__ + "static/lottery-pointer-disable.a7760e00.png";